import React from 'react';

import { ApIcon, colors } from '@alixpartners/ui-components';
import { ColumnChart } from './ColumnChart';
import { Legend } from './Legend';
import { CHART_COLORS, getMonthCategories } from './utils';
import {
	Section,
	Title,
	ChartWrapper,
	ArrowRight,
	ArrowWrapper,
	MainChartWrapper,
	SubHeaderWrapper,
	Helper,
	SubTitleWrapper,
} from './BudgetOverview.styles';

const CATEGORIES = ['YTD incremental savings'];

export const SecondChartSection = ({
	axisTitle,
	data,
	spendFormatter,
	selectedIndex,
	selectColumn,
}) => {
	const { overallVariance, monthlyVariance } = data;
	const isBudgetOverrun = overallVariance < 0;

	const getTotalSeriesData = () => {
		return [
			{
				data: [
					{
						color: isBudgetOverrun ? CHART_COLORS.RED : CHART_COLORS.GREEN,
						y: overallVariance,
					},
				],
			},
		];
	};

	const getMainSeriesData = () => {
		const seriesData = monthlyVariance.map(value => ({
			y: value,
			color: value < 0 ? CHART_COLORS.RED : CHART_COLORS.GREEN,
		}));

		return [{ data: seriesData }];
	};

	return (
		<Section>
			<Title>
				Revised Budget vs. Actuals: Cumulative Incremental Savings Summary
			</Title>
			<SubHeaderWrapper>
				<SubTitleWrapper>
					<ApIcon iconName="touch_app_outlined" iconColor={colors.grey4} />
					<Helper>
						Click the Month bar on the chart to filter the data below
					</Helper>
				</SubTitleWrapper>
				<Legend />
			</SubHeaderWrapper>
			<ChartWrapper>
				<ColumnChart
					categories={CATEGORIES}
					series={getTotalSeriesData()}
					spendFormatter={spendFormatter}
					title={axisTitle}
					width={275}
					selectedIndex={selectedIndex == null ? 0 : null}
					onClick={() => {
						selectColumn(null);
					}}
					plotBandStep={0.17}
				/>
				<ArrowWrapper>
					<ArrowRight
						color={isBudgetOverrun ? CHART_COLORS.RED : CHART_COLORS.GREEN}
					/>
				</ArrowWrapper>
				<MainChartWrapper>
					<ColumnChart
						categories={getMonthCategories(monthlyVariance.length)}
						series={getMainSeriesData()}
						spendFormatter={spendFormatter}
						title={axisTitle}
						onClick={selectColumn}
						selectedIndex={selectedIndex}
					/>
				</MainChartWrapper>
			</ChartWrapper>
		</Section>
	);
};
